import { useMutation, useQueryClient } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

import { SERVICE_CONFIGS_QUERY_KEY } from '../../AddServicePaymentModal/queries/useCreateServicePayment.query';

export default () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isLoading } = useMutation(
    (id: string) => api.delete(`${API_URL.SERVICE_CONFIGS}/${id}`),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: [SERVICE_CONFIGS_QUERY_KEY],
        });
      },
    }
  );
  return {
    isLoading,
    handleDelete: mutateAsync,
  };
};
